import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fade_bounce_delay_variants,
  bounce_right_to_left_variants_delay,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";
import playIcon from "assets/images/tot/play-icon.png";
import downArrow from "assets/images/sbs/tot-new/down-arrow.png";

const TOTPreGuesGuesser = ({ onStart, category, onModalOpen }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tot-guesser-preguess"
    >
      <motion.div
        variants={bounce_right_to_left_variants_without_children}
        className="you-guesser-div"
      >
        <motion.ul variants={fade_bounce_delay_variants}>
          <li>Try to guess the word from the other player's clues!</li>
          <li>If the word is too tough, you can skip the word to move on.</li>
        </motion.ul>

        <div className="guesser-bottom-content">
          <p className="tot-pick">
            Pick a category and start the round when ready!
          </p>
          <div className="tot-category" onClick={onModalOpen}>
            <p>{category !== "" ? category : "Category"}</p>
            <img src={downArrow} alt="" />
          </div>
        </div>
      </motion.div>

      <motion.button
        variants={bounce_right_to_left_variants_delay}
        className="tot-start-btn"
        onClick={onStart}
      >
        START
        <img alt="" src={playIcon} />
      </motion.button>
    </motion.div>
  );
};

export default TOTPreGuesGuesser;
